import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "mt-2 flex relative" }
const _hoisted_5 = {
  key: 0,
  class: "inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
}
const _hoisted_6 = { class: "flex relative w-full" }
const _hoisted_7 = { class: "flex absolute inset-y-0 left-0" }
const _hoisted_8 = {
  key: 0,
  class: "pl-3 flex items-center pointer-events-none"
}
const _hoisted_9 = {
  class: "h-5 w-5 text-gray-400",
  "aria-hidden": "true"
}
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "text-gray-500 sm:text-sm" }
const _hoisted_12 = ["type", "autocomplete", "name", "id", "placeholder", "value"]
const _hoisted_13 = { class: "flex absolute inset-y-0 right-0" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "text-gray-500 sm:text-sm" }
const _hoisted_16 = { class: "pr-3 flex items-center pointer-events-none" }
const _hoisted_17 = {
  key: 1,
  class: "inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
}
const _hoisted_18 = ["id"]

import {
		ExclamationCircleIcon
	} from "@heroicons/vue/24/outline"

	import {
		computed,
		ref,
		nextTick,
		onMounted,
		useSlots
	} from "vue"

	
export default /*@__PURE__*/_defineComponent({
  __name: 'TwInput',
  props: {
		modelValue: {
			type: [String, Number],
			default: null
		},
		autocomplete: {
			type: String,
			default: ''
		},
		error: {
			type: String,
			default: ''
		},
		help: {
			type: String,
			default: ''
		},
		hint: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		}, 
		placeholder: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'text'
		},
		validation: {
			type: String,
			default: ''
		}
	},
  emits: [
		'update:modelValue'
	],
  setup(__props, { emit: __emit }) {

	const props = __props

	const emit = __emit

	const slots = useSlots()

	// padding for inline input elements
	const leadingInlinePadding = ref('none')
	const trailingInlinePadding = ref('none')
	let leadingInlineWidth = 0
	let trailingInlineWidth = 0
	onMounted(() => {
		const leadingEl = document.getElementById(`leading-inline-${props.label}`)
		if(leadingEl){
			leadingInlineWidth = leadingEl.offsetWidth
			leadingInlinePadding.value = String(Math.ceil(leadingInlineWidth / 4) + 1 + ( slots.icon ? 8 : 0 ) )
		}

		const trailingEl = document.getElementById(`trailing-inline-${props.label}`)
		if(trailingEl){
			trailingInlineWidth = trailingEl.offsetWidth
			trailingInlinePadding.value = String(Math.ceil(trailingInlineWidth / 4) + 1 + ( !valid.value ? 8 : 0 ) )
		}
	})

	// update modeled value
	const onInput = async ({ target }: any) => {
		emit('update:modelValue', target.value)
		await nextTick()
		validate()
		return
	}

	// input validation
	const valid = ref(true)
	function validate(){
		if(props.required && !props.modelValue ){
			valid.value = false
		}
		else if(props.required && props.modelValue){
			valid.value = true
		}
	}

	// an error passed in by the parent (e.g. a failed format check) overrides the built-in required check
	const showInvalid = computed(() => !valid.value || !!props.error)

	// shows the parent's error when present, otherwise the built-in validation message
	const validationMessage = computed(() => props.error || props.validation)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: __props.id,
        class: "block text-sm font-bold leading-6 text-gray-900 dark:text-gray-200"
      }, _toDisplayString(__props.label), 9, _hoisted_2),
      (__props.hint)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "text-sm text-gray-500",
            id: `hint-${__props.label}`
          }, _toDisplayString(__props.hint), 9, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.$slots.leading_addon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createElementVNode("span", null, [
              _renderSlot(_ctx.$slots, "leading_addon")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.$slots.icon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _renderSlot(_ctx.$slots, "icon")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.leading_inline)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                id: `leading-inline-${__props.label}`,
                class: "pl-3 flex items-center pointer-events-none"
              }, [
                _createElementVNode("span", _hoisted_11, [
                  _renderSlot(_ctx.$slots, "leading_inline")
                ])
              ], 8, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("input", {
          type: __props.type ?? 'text',
          autocomplete: __props.autocomplete,
          name: __props.label,
          id: __props.id,
          class: _normalizeClass(["flex-1 min-w-0 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-dbBlue sm:text-sm sm:leading-6 dark:bg-white/5 dark:text-white dark:ring-white/10 dark:focus:ring-indigo-500", [{
							'invalid ': showInvalid.value,
							'rounded-none rounded-r-md': _ctx.$slots.leading_addon && !_ctx.$slots.trailing_addon, 
							'rounded-none rounded-l-md': !_ctx.$slots.leading_addon && _ctx.$slots.trailing_addon, 
							'rounded-none': _ctx.$slots.leading_addon && _ctx.$slots.trailing_addon, 
							'rounded-md': !_ctx.$slots.leading_addon && !_ctx.$slots.trailing_addon
						},
						_ctx.$slots.leading_inline ? `pl-${leadingInlinePadding.value}` : '',
						_ctx.$slots.trailing_inline ? `pr-${trailingInlinePadding.value}` : '',
					]]),
          placeholder: __props.placeholder,
          onInput: onInput,
          value: __props.modelValue
        }, null, 42, _hoisted_12),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("div", {
            id: `trailing-inline-${__props.label}`,
            class: "pr-3 flex items-center pointer-events-none"
          }, [
            _createElementVNode("span", _hoisted_15, [
              _renderSlot(_ctx.$slots, "trailing_inline")
            ])
          ], 8, _hoisted_14), [
            [_vShow, _ctx.$slots.trailing_inline && !showInvalid.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_16, [
            _createVNode(_unref(ExclamationCircleIcon), {
              class: "h-5 w-5 text-red-500",
              "aria-hidden": "true"
            })
          ], 512), [
            [_vShow, showInvalid.value]
          ])
        ])
      ]),
      (_ctx.$slots.trailing_addon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
            _createElementVNode("span", null, [
              _renderSlot(_ctx.$slots, "trailing_addon")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("p", {
      class: "mt-2 text-sm text-gray-500",
      id: `help-${__props.label}`
    }, _toDisplayString(__props.help), 9, _hoisted_18), [
      [_vShow, !showInvalid.value && __props.help || showInvalid.value && !validationMessage.value]
    ]),
    _withDirectives(_createElementVNode("p", { class: "mt-1 text-sm text-red-600 -mb-6 dark:text-red-500 font-bold" }, _toDisplayString(validationMessage.value), 513), [
      [_vShow, showInvalid.value]
    ])
  ]))
}
}

})